import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "source" }

import { Link } from '@/models/link.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LinksField',
  props: {
  label: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Object as PropType<Link[]>,
    required: true,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const sources = ref<Link[]>([...(props.modelValue || [])]);

const emit = __emit;

function update() {
  emit('update:modelValue', sources.value);
  emit('change');
}

function addLink() {
  sources.value.push({
    description: '',
    href: '',
  });
  update();
}

function removeLink(index: number) {
  sources.value.splice(index, 1);
  update();
}

watch(
  () => props.modelValue,
  () => {
    Object.assign(sources.value, props.modelValue);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", null, _toDisplayString(__props.label) + "s", 1),
    _createVNode(_component_v_list, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sources.value, (source, index) => {
          return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_text_field, {
                  modelValue: source.description,
                  "onUpdate:modelValue": ($event: any) => ((source.description) = $event),
                  label: "Link",
                  width: "50%",
                  placeholder: `Link ${index + 1}`,
                  required: "",
                  onChange: update
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                _cache[0] || (_cache[0] = _createTextVNode("   ")),
                _createVNode(_component_v_text_field, {
                  modelValue: source.href,
                  "onUpdate:modelValue": ($event: any) => ((source.href) = $event),
                  modelModifiers: { number: true },
                  width: "50%",
                  label: "href",
                  required: "",
                  onChange: update
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete-outline",
                  class: "remove-button",
                  density: "compact",
                  onClick: _withModifiers(($event: any) => (removeLink(index)), ["prevent"])
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      onClick: addLink,
      color: "success"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Add " + _toDisplayString(__props.label), 1)
      ]),
      _: 1
    })
  ]))
}
}

})